import React, { 
  useState,
  useEffect
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import { validateExpenseArrayObjects } from '../../Components/Validations/ArrayObjectValidation';

import { 
  Layout,
  Table,
  Col, 
  Row,
  Button,
  // Modal,
  Upload,
  Divider,
  Form,
  Select,
  Input,
  DatePicker,
  Radio,
  InputNumber,
  Space,

} from 'antd'
import { 
  InboxOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { formatAmount } from '../../Utils/Common';
import { useNavigate } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
// const { Search } = Input;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;

const AddExpense = () => {
  const [addExpenseForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    addExpenseForm.resetFields();
    navigate('/expense')
  });
  const navigate = useNavigate()
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [unitId, setUnitId] = useState('');
  const [tenantData, setTenantData] = useState([]);
  const [ownerData, setOwnerData] = useState([]);
  const [rentalUnitData, setRentalUnitData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [type, setType] = useState('internal');
  // const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [dataSource, setDataSource] = useState([
    {
      items: '',
      amounts: '',
    },
    {
      items: '',
      amounts: '',
    },
  ]);

  const values = Form.useWatch([], addExpenseForm);
  React.useEffect(() => {
      addExpenseForm.validateFields({
      validateOnly: true,
      }).then(() => {
      setIsDisabled(false);
      },
      () => {
      setIsDisabled(true);
      },
      );
  }, [values, addExpenseForm]);

  const handleInputChange = (e, fieldName, recordKey) => {
    const updatedDataSource = dataSource.map((item, index) => {
      if (index === recordKey) {
        if(fieldName === "amounts"){
          return { ...item, [fieldName]: e };
        } else {
          return { ...item, [fieldName]: e.target.value };
        }
      }
      return item;
    });
    setDataSource(updatedDataSource);
  };
  const handleAddRow = () => {
    const newRow = {
      items: "",
      amounts: "",
    };
    setDataSource(prev => [...prev, newRow]);
  };

  const handleDeleteRow = (rowId) => {
    const newData = [...dataSource];
    newData.splice(rowId, 1); 
    setDataSource(() => newData)
  };

  // Calculate grand total
  const grandTotal = dataSource.reduce((total, item) => {
    // Convert amount to number and add to total
    return total + parseFloat(item.amounts || 0);
  
  }, 0);

  const columns = [
    {
      title: 'Items',
      dataIndex: 'items',
      render: (_, record, index) => (
        <Input
          value={record.items}
          onChange={(e) => handleInputChange(e, 'items', index)}
        />
      ),
    },
    {
      title: 'Amounts',
      dataIndex: 'amounts',
      render: (_, record, index) => (
        <InputNumber
          style={{width:'100%'}}
          value={record.amounts}
          onChange={(e) => handleInputChange(e, 'amounts', index)}
        />
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      align: 'center',
      render: (_,record, index) => (
       <div className='center'>
          <Button
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteRow(index)}
            type="link"
            size='large'
            danger
          />
       </div>
      ),
    },
  ];

  const options = [
    {
      label: 'Cash',
      value: 'cash',
    },
    {
      label: 'Check',
      value: 'check',
    },
    {
      label: 'Other',
      value: 'others',
    },
  ];
  async function fetchTenantData() {
    const response = await UseGetRequest("tenants/get", {tenant_id: ''});
    if (response.data) {
      setTenantData(response.data.data);
    } else {
      setTenantData([])
    }
  }

  async function fetchOwnerData() {
    const response = await UseGetRequest("owners/get", {owner_id: ''});
    if (response.data) {
      setOwnerData(response.data.data);
    } else {
      setOwnerData([])
    }
  }

  async function fetchRentalUnitOwner(ownerId) {
    const response = await UseGetRequest("rental_units/get", {owner_id: ownerId});
    if (response?.data) {
      setRentalUnitData(response?.data?.data);
    } else {
      setRentalUnitData([])
    }
  }

  async function fetchSupplierData() {
    const response = await UseGetRequest("suppliers/get", {supplier_id: ''});
    if (response.data) {
      setSupplierData(response.data.data);
    } else {
      setSupplierData([])
    }
  }


  const handleAddExpense = () => {
    addExpenseForm.validateFields().then(values => {
      const resetData = {
        supplier_id: values?.supplier_id || "",
        tenant_id: values?.tenant_id || "",
        owner_id: values?.owner_id || "",
        ...(type === "tenant" ? {rental_unit_id: unitId || ""} : {rental_unit_id: values?.rental_unit_id || ""}),
        main_usage: values?.main_usage || "",
        sub_usage: values?.sub_usage || "",
        description: values?.description || "",
        remarks: values?.remarks || "",
        total: grandTotal || "",
        
        payment_type: paymentMethod || "",
        paid_amount: values?.paid_amount || "",
        payment_remarks: values?.payment_remarks || "",

        check_no: values?.check_no || "",
        bank: values?.bank || "",

        other_type: values?.other_type || "",
        reference_no: values?.reference_no || "",
      };

        resetData.expense_date = values?.expense_date ? values.expense_date.format("YYYY-MM-DD") : "";
        resetData.date_covered = values?.date_covered ? values.date_covered.format("YYYY-MM-DD") : "";
        resetData.payment_date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";
        resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
        
        resetData.items = dataSource.map((item)=>item.items)
        resetData.amounts = dataSource.map((item)=>item.amounts)

        const file = attachmentsData.map((file) => {
            return file.originFileObj;
        });
        
        var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
            key,
            value,
        }));


        callPost(
            "expenses/create", 
            finalValues,
            true,
        );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const onMethodChange = ({ target: { value } }) => {
    setPaymentMethod(value);
  };

  const handleDeleteAttachment = (file) => {
    const updatedAttachments = attachmentsData.filter(item => item !== file);
    setAttachmentsData(updatedAttachments);
  };


  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };

  const handleType = (value) => {
    setType(value)
    addExpenseForm.resetFields(['bank','check_date','check_no', 'other_type', 'reference_no']);
  };  

  const handleUnits = (rental_id, type) => {
    if(type === "owner"){
      fetchRentalUnitOwner(rental_id)
    } else if (type === "tenant"){
      var renter = tenantData.filter(item => item.id === rental_id)
      setUnitId(renter[0]?.rental_unit_id)
    } else {
      setRentalUnitData([])
    }
  }

  useEffect(() => {
    switch (type) {
      case "tenant":
        fetchTenantData();
        break;
      case "owner":
        fetchOwnerData();
        break;
      default:
        break;
    }
  }, [type]);

  useEffect(() => {
    fetchSupplierData();
  }, []);

  useEffect(() => {
    addExpenseForm.setFieldsValue({
      paid_amount: grandTotal
    });
  }, [grandTotal, addExpenseForm]);

  return (
    <Layout className='page'>
      <Navbar/>
      <Layout className='content-container overflow-y'>
          <Row>
              <Col span={24} className='header-container p-3'>
                  ADD EXPENSE
              </Col>
          </Row>
          <Row>
              <Col span={24} className='p-3'>
                  <Form form={addExpenseForm} layout="vertical">
                    <Divider className='divider-text'>Unit Information</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Supplier Tradename"
                            name="supplier_id"
                            rules={[{ required: true, message: 'Please select your Supplier' }]} // Adjusted message
                          >
                            <Select placeholder="Select a supplier">
                              {supplierData.map((option, index) => (
                                <Option key={index} value={option.id}>{option.tradename}</Option>
                              ))}
                            </Select>
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                              label="Expense Date"
                              name="expense_date"
                              // className="mt-2"
                              rules={[{ required: true, message: 'Please select a Expense Date' }]}
                          >
                              <DatePicker style={{ width: '100%' }} />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Expense Description"
                            name="description"
                            rules={[{ required: true, message: 'Please enter your Description!' }]}
                          >
                            <Input />
                          </Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Usage"
                            name="main_usage"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <Input />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Sub Usage"
                            name="sub_usage"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <Input />
                          </Item>
                        </Col>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Date Covered"
                            name="date_covered"
                            // className="mt-2"
                            // rules={[{ required: true, message: 'Please select a Date Covered' }]}
                          >
                            <DatePicker style={{ width: '100%' }} />
                          </Item>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Type"
                            name="type"
                          >
                            <Select placeholder="Select a Type" onChange={handleType}>
                              <Option key='internal' value="internal">Internal</Option>
                              <Option key='tenant' value="tenant">Tenant</Option>
                              <Option key='owner' value="owner">Owner</Option>
                            </Select>
                          </Item>
                        </Col>
                        {
                          type === "tenant" && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Tenant"
                                name="tenant_id"
                                rules={[{ required: true, message: 'Please select a Tenant' }]}

                              >
                                <Select 
                                  placeholder="Select a Tenant"
                                  showSearch
                                  onChange={(e) => handleUnits(e, "tenant")}
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {tenantData.map((option, index) => (
                                    <Option key={index} value={option.id}>{option.concatenated_tenant}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                        {
                          type === "owner" && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Owner"
                                name="owner_id"
                                rules={[{ required: true, message: 'Please select a Owner' }]}
                              >
                                <Select 
                                  placeholder="Select a Owner"
                                  showSearch
                                  onChange={(e) => handleUnits(e, "owner")}
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {ownerData.map((option, index) => (
                                    <Option key={index} value={option.id}>{option.name}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                        {
                          (type === "owner") && (
                            <Col span={8} className='p-2'>
                              <Item
                                label="Rental Unit"
                                name="rental_unit_id"
                                rules={[{ required: true, message: 'Please select a Rental Unit' }]}
                              >
                                <Select 
                                  placeholder="Select a Owner"
                                  showSearch
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                >
                                  {rentalUnitData.map((option, index) => (
                                    <Option key={index} value={option.id}>{option.name}</Option>
                                  ))}
                                </Select>
                              </Item>
                            </Col>
                          )
                        }
                       
                      </Row>
                      <Row>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Remarks"
                            name="remarks"
                            // rules={[{ required: true, message: 'Please enter your Name!' }]}
                          >
                            <Input />
                          </Item>
                        </Col>
                      </Row>
                      <Divider className='divider-text'>List of Purchased Items</Divider>
                      {
                        validateExpenseArrayObjects(dataSource) && (
                          <Row>
                            <Col span={24} className='p-3 logout-icon'>
                              Required*
                            </Col>
                          </Row>
                        )
                      }
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                        <Table
                          dataSource={dataSource}
                          columns={columns}
                          pagination={false}
                          bordered
                        />
                        <Button type="primary" className='mt-4' onClick={handleAddRow}>
                          Add Row
                        </Button>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={12}>
                         
                        </Col>
                        <Col span={12} className='p-3 amount-total' align='right'>
                          Total: {formatAmount(grandTotal)}
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                          <Form form={addExpenseForm} layout="vertical">
                            <Item 
                              label="Attachment"
                              name="attachments" 
                              // valuePropName="fileList" 
                              getValueFromEvent={normFile} 
                              noStyle
                            >
                              <Upload.Dragger 
                                multiple
                                name="files" 
                                // action="/upload.do"
                                fileList={attachmentsData}               
                                beforeUpload={() => false}
                                onRemove={handleDeleteAttachment}
                              >
                              <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">Click or drag file to this area to upload</p>
                              <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                              </Upload.Dragger>
                            </Item>
                          </Form>
                        </Col>
                      </Row>
                    
                      {
                        (type === "internal") && (
                          <>
                            <Divider className='divider-text'>Add Payment</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                              <Col span={24} className='p-2'>
                                  <Radio.Group options={options} onChange={onMethodChange} value={paymentMethod} optionType="button" />
                              </Col>
                            </Row>

                            <Form form={addExpenseForm} layout="vertical">
                              <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Amount"
                                    name="paid_amount"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Name!' }]}
                                  >
                                    <InputNumber
                                      style={{width:'100%'}}
                                      disabled
                                      min={0}
                                      max={grandTotal}
                                    />
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Payment Date"
                                    name="payment_date"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Payment Date!' }]}
                                  >
                                    <DatePicker style={{width:'100%'}}/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Remarks"
                                    name="payment_remarks"
                                    className='p-0 m-0'
                                  >
                                    <TextArea/>
                                  </Item>
                                </Col>
                              </Row>
                              <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                {
                                  paymentMethod === "check" && (
                                    <>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Bank Name"
                                          name="bank"
                                          className='p-0 m-0'
                                          rules={
                                            [
                                              { required: true, message: 'Please enter your Bank Name!' }
                                            ]
                                          }
                                        >
                                          <Input/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Check Date"
                                          name="check_date"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Check Date!' }]}
                                        >
                                          <DatePicker style={{width:'100%'}}/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Check Number"
                                          name="check_no"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Check Number!' }]}
                                        >
                                          <Input/>
                                        </Item>
                                      </Col>
                                    </>
                                  )
                                }
                                {
                                  paymentMethod === "others" && (
                                    <>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Type"
                                          name="other_type"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Type!' }]}
                                        >
                                          <Input/>
                                        </Item>
                                      </Col>
                                      <Col span={8} className='p-2'>
                                        <Item
                                          label="Reference Number"
                                          name="reference_no"
                                          className='p-0 m-0'
                                          rules={[{ required: true, message: 'Please enter your Reference Number!' }]}
                                        >
                                          <Input/>                                  
                                        </Item>
                                      </Col>
                                    </>
                                  )
                                }
                              </Row>
                            </Form>
                          </>
                        )
                      }

                      <Row className='btn-footer'>
                        <Space className='p-2'>
                          <Button
                            onClick={() => navigate('/expense')}
                            className='btn-header'
                          >
                            Close
                          </Button>
                        
                          <Button
                            onClick={handleAddExpense}
                            type='primary'
                            loading={loading}
                            className='btn-header'
                            disabled={
                              validateExpenseArrayObjects(dataSource) ||
                              isDisabled
                            }
                          >
                            Save
                          </Button>
                        </Space>
                      </Row>
                  </Form>
              </Col>
          </Row>
      </Layout>
  </Layout>
)
}

export default AddExpense
